import React from 'react';
export const FooterSection = () => {
  return <footer className="bg-teal-900 text-white py-12" data-id="element-142">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-143">
        <div className="mb-8 bg-teal-800/50 p-6 rounded-lg" data-id="element-144">
          <h3 className="text-xl font-bold mb-4" data-id="element-145">Disclaimer:</h3>
          <p className="text-teal-100" data-id="element-146">
            Neurotoned is a wellness education program and is not intended to
            diagnose, treat, or cure any medical or mental health condition.
            Always consult with a licensed healthcare provider before beginning
            any new wellness program, especially if you are currently in
            treatment or on medication. Neurotoned is not a substitute for
            professional therapy, medical care, or crisis support.
          </p>
        </div>
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-147">
          <div className="mb-4 md:mb-0" data-id="element-148">
            <a href="https://www.neurotoned.com" className="flex items-center" data-id="element-149">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rrHy2EJ66VVPMZwVzkfGjw/Healing_isn%E2%80%99t_about_forgetting_%E2%80%94_it%E2%80%99s_about_rewiring.-min.png" alt="Neurotoned Logo" className="w-10 h-10 rounded-full mr-2" data-id="element-150" />
              <span className="font-bold" data-id="element-151">Neurotoned</span>
            </a>
          </div>
          <div className="flex flex-col md:flex-row gap-4 text-sm" data-id="element-152">
            <a href="https://www.neurotoned.com/terms-and-conditions" className="text-teal-200 hover:text-white transition-colors" data-id="element-153">
              Terms of Service
            </a>
            <a href="https://www.neurotoned.com/privacy-policy" className="text-teal-200 hover:text-white transition-colors" data-id="element-154">
              Privacy Policy
            </a>
            <a href="mailto:support@neurotoned.com" className="text-teal-200 hover:text-white transition-colors" data-id="element-155">
              Contact: support@neurotoned.com
            </a>
          </div>
        </div>
        <div className="text-center mt-8 text-sm text-teal-300" data-id="element-156">
          &copy; {new Date().getFullYear()} Neurotoned. All rights reserved.
        </div>
      </div>
    </footer>;
};